<template>
  <div>
    <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
      <a-form-item label="会议名称">
        <span>
          {{ data.title }}
          <a-button
            v-if="hasSignPermission"
            type="primary"
            class="pass-btn"
            size="small"
            style="float: right;margin-right: 10px;"
            @click="onReviewPass"
          > 通过</a-button>
        </span>
      </a-form-item>
      <a-form-item label="状态">
        <template v-if="reviewStatus[data.status]">
          <!-- <a-tag :color="reviewStatus[data.status].color">{{ reviewStatus[data.status].label }}</a-tag> -->
          <review-status-edit :review-id="data.id" :next-status="data.next_status" :status="data.status" @change="changeStatus" />
        </template>
        <template v-else>
          {{ data.status }}
        </template>
      </a-form-item>
      <a-form-item label="时间">
        {{ data.review_time }}
      </a-form-item>
      <a-form-item label="发起人">
        <span v-for="reviewer in userList([data.creator])" :key="reviewer.id">
          <a-avatar :size="20" :src="reviewer.avatar_url" /> <span class="nickname">{{ reviewer.nickname }} </span>
        </span>
      </a-form-item>
      <a-form-item label="参与人">
        <span v-for="reviewer in userList(data.reviewers)" :key="reviewer.id">
          <a-avatar :size="20" :src="reviewer.avatar_url" /> <span class="nickname">{{ reviewer.nickname }} </span>
        </span>
      </a-form-item>
      <!-- <a-form-item label="会议纪要">

      </a-form-item> -->
      <!-- <a-form-item label="参与人确认">
        线下评审商品评价MRD
      </a-form-item> -->
    </a-form>
    <CommentPanel mode="business_requirement_review" :active-key="[]" :source-id="data.id" />
  </div>
</template>

<script>
import CommentPanel from '@/components/comment/CommentPanel';
import { reviewStatus } from '@/utils/dictionary';
import ReviewStatusEdit from '@/pages/project/review/components/ReviewStatusEdit';
import store from '@/store';
export default {
  components: { CommentPanel, ReviewStatusEdit },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      reviewStatus,
      key: 0,
      spinning: false,
      loading: false,
      visible: false,
      dataList: {},
      tabsCurrent: 1,
      userData: [],
      hasSignPermission: false
    };
  },
  computed: {
    userList() {
      return (items) => {
        if (!items) return [];
        const list = store.state.allUsers;
        if (list) {
          return list.filter(item => items.includes(item.id));
        }
        return [];
      };
    }
  },
  methods: {
    changeStatus() {
      this.$emit('changeStatus');
    },
    onReviewPass() {

    }
  }
};
</script>

<style lang="less" scoped>

/deep/.ant-form-item {
  margin-bottom: 8px;
}
</style>
